import { Component } from "@angular/core";
import { DevextremesharedmoduleModule } from "../../../../../shared/Module/devextremeshared/devextremeshared.module";
import { CancelbuttonComponent } from "../../../../../shared/components/cancelbutton/cancelbutton.component";
import {
  DomainEnums,
  Month,
  OperationalModes,
} from "../../../../../classes/infrastructure/enums";
import { UIUtils } from "../../../../../services/uiutils.service";
import { Router } from "@angular/router";
import { AppStateManageService } from "../../../../../services/app-state-manage.service";
import { Utils } from "../../../../../services/utils.service";
import notify from "devextreme/ui/notify";
import { MonthYearInitService } from "../../../../../services/finantial-year-wise-months.service";
import { NavItem_Entity_Authority } from "../../../../../shared/components/side-navigation-menu/side-navigation-menu.component";
import { SidebarMenuStateService } from "../../../../../services/sidebarmenustateservice";
import { HealthDepartmentProfile } from "../../../../../classes/domain/entities/website/masters/landing-page/health-department-profile/healthdepartmentprofile";
import { FileTransferObject } from "../../../../../classes/infrastructure/filetransferobject";
import { BaseUrlService } from "../../../../../services/baseurl.service";
import { SUBMENU_ID } from "../../../../../classes/domain/constants";

export interface SelectedPhotos {
  label: string;
  preview: string;
  // New uploads
  file?: File;
  filename?: string;
  // Edit mode (existing images)
  isExisting: boolean;
  path?: string;
}

@Component({
  selector: "app-health-department-profile-master-details",
  templateUrl: "./health-department-profile-master-details.component.html",
  styleUrl: "./health-department-profile-master-details.component.scss",
  standalone: true,
  imports: [DevextremesharedmoduleModule, CancelbuttonComponent],
})
export class HealthDepartmentProfileMasterDetailsComponent {
  Entity: HealthDepartmentProfile = HealthDepartmentProfile.CreateNewInstance();
  isSaveDisabled: boolean = false;
  IsNewEntity: boolean = true;
  InitialEntity: HealthDepartmentProfile = null as any;
  DetailsFormTitle:
    | "Add Health Department Profile"
    | "Edit Health Department Profile" = "Add Health Department Profile";
  isChecked: boolean = false;
  MasterList: HealthDepartmentProfile[] = [];

  MonthList = DomainEnums.MonthList(true, "Select Month");
  ContraceptivePillsTypesList = DomainEnums.ContraceptivePillsTypeList(
    true,
    "Select",
  );

  // Financial Year related
  currentMonth: number = 0;
  PreviousMonth: number = 0;
  CurrentFinancialYear: string = "";
  March = Month.March;
  April = Month.April;
  YearsList: { Ref: number; Name: string }[] = [];
  isApril: boolean = false;

  LoginRole: number = 0;

  EntityType: string = "Health_Department_Profile_Master";
  EntityAuthority: NavItem_Entity_Authority | undefined = undefined;
  CanAddOrEdit: boolean = false;
  IsReadOnlyMode: boolean = false;
  isEditMode: boolean = false;
  operationMode: OperationalModes = OperationalModes.CanAdd;
  IsViewMode: boolean = false;

  SelectedPhotos: SelectedPhotos[] = [];
  DeletedDocumentPaths: string[] = []; // optional (if backend supports delete)
  MAX_PHOTOS = 1;
  LoginToken: string = '';

  constructor(
    private uiUtils: UIUtils,
    private router: Router,
    private appStateManage: AppStateManageService,
    private utils: Utils,
    private monthYearService: MonthYearInitService,
    private sidebarMenuState: SidebarMenuStateService,
    private baseUrl: BaseUrlService,

  ) {
    const navigation = this.router.getCurrentNavigation();
    const fromMaster = navigation?.extras?.state?.["fromMaster"];

    if (!fromMaster) {
      this.router.navigate(["/"]);
      return;
    }
    this.operationMode =
      navigation?.extras?.state?.["mode"] ?? OperationalModes.CanAdd;

    this.IsNewEntity = this.operationMode === OperationalModes.CanAdd;
    this.IsViewMode = this.operationMode === OperationalModes.CanView;
    this.isEditMode = this.operationMode === OperationalModes.CanEdit;
  }

  async ngOnInit() {
    this.LoginToken = this.appStateManage.getLoginToken();
    this.sidebarMenuState.menu$.subscribe((menu) => {
      let SideBarMenuItemList = menu;
      console.log('SideBarMenuItemList :', SideBarMenuItemList);
      this.EntityAuthority = SideBarMenuItemList.find(
        (e) => e.MenuId == this.EntityType,
      );
      this.applyPermission();
    });

    // Allow access only when coming from table; refresh or direct URL is blocked
    if (!sessionStorage.getItem("fromTable")) {
      this.router.navigate(["HEALTH_DEPARTMENT_PROFILE_MASTER"]);
      return;
    }
    sessionStorage.removeItem("fromTable"); // Clear flag so refresh on details page redirects back to table

    const stored = this.appStateManage.StorageKey.getItem(
      "FinancialYearResponses",
    );
    const financialYearResponses = stored ? JSON.parse(stored) : [];
    if (financialYearResponses.length > 0) {
      this.CurrentFinancialYear = financialYearResponses[0].financial_year_id;
    } else {
      this.YearsList = financialYearResponses;
      this.isApril = true;
    }

    this.isEditMode =
      this.appStateManage.StorageKey.getItem("Editable") == "Edit";
    // ✅ SECOND: Load hierarchy data

    // ✅ THIRD: Apply appropriate filters based on mode
    if (this.isEditMode) {
      this.IsNewEntity = false;
      this.DetailsFormTitle = this.IsNewEntity
        ? "Add Health Department Profile"
        : "Edit Health Department Profile";
      this.Entity = HealthDepartmentProfile.GetCurrentInstance();
      this.appStateManage.StorageKey.removeItem("Editable");
      this.loadExistingImagesForEdit();
    } else {
      // ➕ ADD MODE
      this.IsNewEntity = true;
      this.DetailsFormTitle = "Add Health Department Profile";

      // ✅ Service already has the current filter state from table
      // Just patch it into entity
    }
    this.applyPermission();

    this.InitialEntity = Object.assign(
      HealthDepartmentProfile.CreateNewInstance(),
      this.utils.DeepCopy(this.Entity),
    ) as HealthDepartmentProfile;
  }

  private applyPermission(): void {
    if (!this.EntityAuthority) {
      this.CanAddOrEdit = false;
      this.IsReadOnlyMode = true;
      return;
    }
    switch (this.operationMode) {
      case OperationalModes.CanView:
        this.CanAddOrEdit = false;
        this.IsReadOnlyMode = true;
        break;

      case OperationalModes.CanAdd:
        this.CanAddOrEdit = this.EntityAuthority.CanAdd ?? false;
        this.IsReadOnlyMode = !this.CanAddOrEdit;
        break;

      case OperationalModes.CanEdit:
        this.CanAddOrEdit = this.EntityAuthority.CanEdit ?? false;
        this.IsReadOnlyMode = !this.CanAddOrEdit;
        break;

      default:
        this.CanAddOrEdit = false;
        this.IsReadOnlyMode = true;
        break;
    }
  }


  loadExistingImagesForEdit() {
    this.SelectedPhotos = [];
    const paths = [
      this.Entity.p.profile_pic_path,

    ].filter((p): p is string => !!p);

    const imageBaseUrl = this.baseUrl.GenerateImageBaseUrl();

    paths.forEach((path, index) => {
      this.SelectedPhotos.push({
        label: `Document${index + 1}File`,
        preview: `${imageBaseUrl}${path}/${this.LoginToken}`,
        isExisting: true,
        path: path,
      });
    });
  }

  onFileSelect(e: any) {
    const files: File[] = e.value || [];
    const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

    files.forEach((file) => {
      // 🔴 Check file size limit (10MB)
      if (file.size > MAX_SIZE) {
        this.uiUtils.showErrorMessage("Error", "Image must be less than 10 MB");
        return;
      }
      if (this.SelectedPhotos.length >= this.MAX_PHOTOS) return;

      this.SelectedPhotos.push({
        label: `profile_pic_file`,
        file: file,
        filename: file.name,
        preview: URL.createObjectURL(file),
        isExisting: false,
      });
    });
  }

  compressImage(file: File, maxSizeMB: number = 2): Promise<File> {
    return new Promise((resolve) => {
      const img = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        img.src = event.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        // 🔽 Resize if needed (optional)
        let width = img.width;
        let height = img.height;

        const maxWidth = 1920;
        if (width > maxWidth) {
          height = (maxWidth / width) * height;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        // 🔽 Reduce quality until size < 2MB
        let quality = 0.9;

        const compressLoop = () => {
          canvas.toBlob((blob) => {
            if (!blob) return;

            if (blob.size <= maxSizeMB * 1024 * 1024 || quality <= 0.1) {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
              });
              resolve(compressedFile);
            } else {
              quality -= 0.1;
              compressLoop();
            }
          }, file.type, quality);
        };

        compressLoop();
      };
    });
  }

  removePhoto(index: number) {
    const photo = this.SelectedPhotos[index];

    if (!photo.isExisting && photo.preview) {
      URL.revokeObjectURL(photo.preview);
    }

    // Optional: if backend supports delete
    if (photo.isExisting && photo.path) {
      this.DeletedDocumentPaths.push(photo.path);
    }
    this.SelectedPhotos.splice(index, 1);
    // Re-label to keep Document1..4 correct
    this.SelectedPhotos.forEach((p, i) => {
      p.label = `Document${i + 1}File`;
    });
  }

  selectAllValue(event: MouseEvent): void {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  SaveHealthDepartmentProfile = async () => {
    this.Entity.p.created_by = this.appStateManage.getLoginUserRef();
    this.Entity.p.updated_by = this.appStateManage.getLoginUserRef();

    this.Entity.p.profile_pic_path = '';
    // 🔁 Reassign sequentially based on remaining photos
    this.SelectedPhotos.forEach((photo, index) => {
      const path = photo.isExisting
        ? photo.path              // existing image
        : photo.filename;         // new image

      if (index === 0) this.Entity.p.profile_pic_path = path ? path : '';
    });


    if (this.SelectedPhotos.length == 0) {
      await this.uiUtils.showErrorMessage("Image Required", "One image is required",);
      return;
    }

    this.isSaveDisabled = true;
    let EntityToSave = this.Entity.GetEditableVersion();
    let entitiesToSave = [EntityToSave];
    const lstFTO: FileTransferObject[] = [];
    for (const p of this.SelectedPhotos.filter(x => !x.isExisting && x.file)) {
      const compressedFile = await this.compressImage(p.file!, 2); // 🔥 2MB limit
      lstFTO.push(FileTransferObject.FromFile(p.label, compressedFile, p.filename!));
      console.log('p.label :', p.label);
    }
    let tr = await this.utils.SavePersistableEntities(entitiesToSave, lstFTO);
    console.log("EntityToSave :", EntityToSave);
    console.log("lstFTO :", lstFTO);

    if (!tr.Successful) {
      this.isSaveDisabled = false;
      this.uiUtils.showErrorMessage("Error", tr.Message);
      return;
    }
    this.isSaveDisabled = false;

    if (this.IsNewEntity) {
      notify("Health Department Profile saved successfully!", "success", 3000);
      this.Entity = HealthDepartmentProfile.CreateNewInstance();
      await this.router.navigate([SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER]);
    } else {
      notify(
        "Health Department Profile Updated successfully!",
        "success",
        3000,
      );
      this.Entity = HealthDepartmentProfile.CreateNewInstance();
      await this.router.navigate([SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER]);
    }
  };

  async BackHealthDepartmentProfile() {
    if (this.isEditMode) {
      // for cancel if not access to edit
    }
    if (!this.utils.AreEqual(this.InitialEntity, this.Entity)) {
      await this.uiUtils.showConfirmationMessage(
        "Cancel",
        `This process is IRREVERSIBLE!
      <br/>
      Are you sure that you want to Cancel Health Department Profile?`,
        async () => {
          await this.router.navigate([SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER]);
        },
      );
    } else {
      await this.router.navigate([SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER]);
    }
  }
}
